import { render, staticRenderFns } from "./CarHealthScreen.vue?vue&type=template&id=19be9868&"
import script from "./CarHealthScreen.vue?vue&type=script&lang=ts&"
export * from "./CarHealthScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports